import { cacheGet, cacheSet } from './cache.js';
import type { VideoData } from '../types.js';

export type FetchVideoOptions = {
  cdnHost?: string; // default: https://edge.dashtrack.com
  signal?: AbortSignal;
};

const DEFAULT_CDN = 'https://edge.dashtrack.com';

function buildVideoUrl(mediaId: number, cdnHost = DEFAULT_CDN): string {
  const host = cdnHost.replace(/\/$/, '');
  return `${host}/assets/videos/${mediaId}`;
}

export async function fetchVideoData(
  mediaId: number,
  options: FetchVideoOptions = {}
): Promise<VideoData> {
  if (!Number.isFinite(mediaId)) {
    throw new Error('Invalid mediaId provided to fetchVideoData');
  }
  const cacheKey = `video:${options.cdnHost ?? DEFAULT_CDN}:${mediaId}`;
  const cached = cacheGet<VideoData>(cacheKey);
  if (cached) return cached;

  const url = buildVideoUrl(mediaId, options.cdnHost);
  const res = await fetch(url, { signal: options.signal });
  if (!res.ok) {
    throw new Error(`Failed to fetch video data (status ${res.status})`);
  }
  const data = (await res.json()) as VideoData;
  cacheSet(cacheKey, data);
  return data;
}
